import { FormBaseDialog } from "components/parts/dialogs";
import { Button } from "@mui/material";

import { FormProvider, useForm } from "react-hook-form";
import { TextField, DialogContent, DialogActions } from "@mui/material";
import { ISectionSchema, sectionSchema } from "./hooks/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormInput } from "components/parts/form";
import { useEffect } from "react";
import { useI18n } from "i18n";

type ISection = {
  id: number;
  name: string;
};

const clearData: ISectionSchema = {
  name: "",
};

const SectionDialog = (props) => {
  const { open, editType, editData, handleClose, handleSubmit } = props;
  const { t } = useI18n();

  const methods = useForm<ISectionSchema>({
    resolver: yupResolver(sectionSchema),
    defaultValues: clearData,
  });

  const { handleSubmit: formSubmit, reset, clearErrors } = methods;

  const onClose = () => {
    if (handleClose) {
      handleClose();
      clearErrors();
      reset(clearData);
    }
  };

  const onSubmit = async (data) => {
    if (handleSubmit) {
      const resultSubmit = await handleSubmit(data);
      if (resultSubmit) {
        handleClose();
        reset(clearData);
      }
    }
  };

  useEffect(() => {
    console.log(editType, editData);
    reset(editData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editType, editData]);

  return (
    <FormBaseDialog
      open={open}
      handleClose={onClose}
      title={
        editType === "edit" ? t("sections.editTitle") : t("sections.addTitle")
      }
      content={
        <>
          <FormProvider {...methods}>
            <form onSubmit={formSubmit(onSubmit)}>
              <DialogContent>
                <FormInput
                  name="name"
                  render={(field, fieldState) => {
                    return (
                      <TextField
                        {...field}
                        label={t("field.sectionName")}
                        type={"text"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        fullWidth
                        margin="dense"
                      />
                    );
                  }}
                />
              </DialogContent>
              <DialogActions>
                <>
                  <Button
                    onClick={() => {
                      onClose();
                    }}
                    color="primary"
                  >
                    {t("common.cancel")}
                  </Button>
                  <Button type="submit" color="primary">
                    {editType === "edit" ? t("common.update") : t("common.add")}
                  </Button>
                </>
              </DialogActions>
            </form>
          </FormProvider>
        </>
      }
    />
  );
};

export { SectionDialog };
export type { ISection };
